import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import React from 'react';

const TableEN = () => {
  return (
    <Table
      style={{margin: '0 15px'}}
      dataSource={[
        { key: '1', permission: 'Creating a terms of access', admin: true, user: false },
        { key: '2',permission: 'Creating an access point',admin: true,user: false },
        { key: '3', permission: 'Editing room settings', admin: true, user: false },
        { key: '4',permission: 'Viewing activity log',admin: true,user: false },
        { key: '5',permission: 'Deleting a room',admin: true,user: false },
        { key: '7',permission: 'Inviting users to a room',admin: true,user: false },
        { key: '8', permission: 'Excluding users from a room', admin: true, user: false },
        { key: '9', permission: 'Creating roles', admin: true, user: false },
        { key: '10', permission: 'Changing a Member Role', admin: true, user: true },
        { key: '11', permission: 'Creating folders', admin: true, user: true },
        { key: '12', permission: 'Editing folders', admin: true, user: true },
        { key: '13', permission: 'Reconciliation management', admin: true, user: true },
        { key: '14', permission: 'Signing management', admin: true, user: true },
        { key: '15',permission: 'Making screenshot', admin: true,user: false },
      ]}
      columns={[
        {
          title: 'Setting up rights',
          dataIndex: 'permission',
          key: 'permission',
          width: '40%',
        },
        {
          title: 'Administrator',
          dataIndex: 'admin',
          key: 'admin',
          align: 'center',
          render: (hasPermission: boolean) =>
            hasPermission ? (
              <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
            ) : (
              <CloseOutlined style={{ color: 'red', fontSize: 20  }} />
            ),
        },
        {
          title: 'User',
          dataIndex: 'user',
          key: 'user',
          align: 'center',
          render: (hasPermission: boolean) =>
            hasPermission ? (
              <CheckOutlined style={{ color: 'green', fontSize: 20  }} />
            ) : (
              <CloseOutlined style={{ color: 'red', fontSize: 20  }} />
            ),
        },
      ]}
      pagination={false}
      bordered
    />
  );
}

export default TableEN;
